import { render } from "./CostiRicaviBiglietteriaFerroviariaSottoProgetto.vue?vue&type=template&id=7e3d3269&scoped=true&ts=true"
import script from "./CostiRicaviBiglietteriaFerroviariaSottoProgetto.vue?vue&type=script&lang=ts"
export * from "./CostiRicaviBiglietteriaFerroviariaSottoProgetto.vue?vue&type=script&lang=ts"

import "./CostiRicaviBiglietteriaFerroviariaSottoProgetto.vue?vue&type=style&index=0&id=7e3d3269&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e3d3269"]])

export default __exports__